import { cn } from '@/lib/utils';

interface ProgressBarProps {
  /** 0-100 */
  value: number;
  className?: string;
  /** Override the auto colour. By default we tint green → amber → rose. */
  tone?: 'auto' | 'success' | 'warn' | 'danger';
}

function toneClass(percent: number, override: NonNullable<ProgressBarProps['tone']>): string {
  if (override === 'success') return 'bg-emerald-500';
  if (override === 'warn') return 'bg-amber-500';
  if (override === 'danger') return 'bg-rose-500';
  if (percent < 60) return 'bg-emerald-500';
  if (percent < 85) return 'bg-amber-500';
  return 'bg-rose-500';
}

export function ProgressBar({ value, className, tone = 'auto' }: ProgressBarProps) {
  const pct = Math.max(0, Math.min(100, value));
  return (
    <div className={cn('h-1.5 w-full overflow-hidden rounded-full bg-zinc-800', className)}>
      <div
        className={cn('h-full transition-all', toneClass(pct, tone))}
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
